const decimals = {
    maximum_digits: 2
}

export default decimals;